import { render, staticRenderFns } from "./chateau-cantemerle.vue?vue&type=template&id=78ff3b7c&scoped=true"
import script from "./chateau-cantemerle.vue?vue&type=script&lang=js"
export * from "./chateau-cantemerle.vue?vue&type=script&lang=js"
import style0 from "./chateau-cantemerle.vue?vue&type=style&index=0&id=78ff3b7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ff3b7c",
  null
  
)

export default component.exports